export function notificationUrl(notification){
  return `/notifications?notification=${encodeURIComponent(notification.id)}`;
}
export function employeeNotificationDestination(notification){
  const target=notification.target||{};
  if(target.tab==='timesheets'||notification.route==='timesheet')return {tab:'more',moreSubTab:'timesheet'};
  if(target.tab==='timeoff')return {tab:'requests',requestsSubTab:/swap/i.test(notification.title)?'swap':'timeoff'};
  if(target.tab==='openShifts')return {tab:'requests',requestsSubTab:'openshifts'};
  if(target.tab==='announcements')return {tab:'home'};
  return {tab:target.screen==='schedule'||notification.route==='schedule'?'schedule':'home'};
}

export function notificationActionLabel(notification) {
  const tab = notification.target?.tab;
  if (tab === 'timesheets' || notification.route === 'timesheet') return 'Review timesheet';
  if (tab === 'timeoff' || /swap|time.?off/i.test(notification.title || '')) return 'View request';
  if (tab === 'openShifts') return 'View open shift';
  if (tab === 'announcements' || notification.category === 'announcements') return 'Read announcement';
  if (notification.target?.screen === 'schedule' || notification.route === 'schedule') return 'View schedule';
  return 'View details';
}
